/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as appProjectsChar123ProjectIdChar125RouteImport } from './routes/(app)/projects.{-$projectId}'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const appProjectsChar123ProjectIdChar125Route =
  appProjectsChar123ProjectIdChar125RouteImport.update({
    id: '/(app)/projects/{-$projectId}',
    path: '/projects/{-$projectId}',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/projects/{-$projectId}': typeof appProjectsChar123ProjectIdChar125Route
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/projects/{-$projectId}': typeof appProjectsChar123ProjectIdChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/(app)/projects/{-$projectId}': typeof appProjectsChar123ProjectIdChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/$' | '/projects/{-$projectId}'
  fileRoutesByTo: FileRoutesByTo
  to: '/$' | '/projects/{-$projectId}'
  id: '__root__' | '/$' | '/(app)/projects/{-$projectId}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  appProjectsChar123ProjectIdChar125Route: typeof appProjectsChar123ProjectIdChar125Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/projects/{-$projectId}': {
      id: '/(app)/projects/{-$projectId}'
      path: '/projects/{-$projectId}'
      fullPath: '/projects/{-$projectId}'
      preLoaderRoute: typeof appProjectsChar123ProjectIdChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  appProjectsChar123ProjectIdChar125Route:
    appProjectsChar123ProjectIdChar125Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
